// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"eca0319c6cb1402b7119","655":"9b416bad0452688bb993"}[chunkId] + ".js";
};